import Component from './twitter_campaign_analytics_dialog.vue'
export default Component
